/* eslint-disable no-unused-expressions */
import React from 'react';
import './CreatePostControlNote.css';
import {connect} from 'react-redux';
import * as PropertyBucket from '../../Properties/Properties';
import {Waiter} from '.././WaitingSign/Waiting';
import * as httpService from '../HttpService/HttpService';
import {
	mapControlBlockOccurance,
	mapNewAttachments,
	mapPaymentClaims,
	serializeInitialAttachmentsForForm
} from '../documents/helpers';
import {PostControlNoteDto} from '../Dtos/PostControlNoteDto';
import PopUp from '.././PopUp/PopUp';
import {PostControlForm} from './PostControlForm'
import {NewPostControlDocumentDto} from "../Dtos/NewPostControlDocumentDto";
import {Prompt} from "react-router-dom";
import {isZrealizowana} from "../ControlStateHelper";
import * as actions from "../../Redux/Actions/Controls";
import {AuditDetail} from "../AuditDetail/AuditDetail";
import {isValidJson, extractJsonsWithPreText, rawToEditorContent, plainTextToEditorContent, mergeContentStates} from "../WysiwygEditor/WysiwygHelpers"
import { convertToRaw } from "draft-js";
import { emptyEditorContentPlainText } from '../../consts/consts';

export const GET_CONTROL_LIST_DATA_REQUESTED = 'GET_CONTROL_LIST_DATA_REQUESTED';
export const GET_CONTROL_LIST_DATA_DONE = 'GET_CONTROL_LIST_DATA_DONE';
export const GET_CONTROL_LIST_DATA_FAILED = 'GET_CONTROL_LIST_DATA_FAILED';

class CreatePostControlNote extends React.Component {

	noteId;

	controlId;

	constructor(props) {
		super(props);
		this.state = {
			showPopup: false,
			popUp: {title: null, notification: null},
			isLocked: true,
			controlData: null,
			noteData: null,
			noteDataSource: null,
			noteContent: null,
			postControlDocumentId: null,
			isWaiting: false,
			classesNote: [],
			isChangeRoutePossible: true,
			isPreventPromptEnabled: true
		};
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
	}

	componentDidMount() {
		if (this.props.match.params.noteId) {
			this.noteId = this.props.match.params.noteId;
			this.controlId = this.props.match.params.controlId;
			this.fetchInfoData(this.controlId);
		}
	}

	parseNoteContent = (noteContent) => {

		if(isValidJson(noteContent)) {
			return noteContent;
		} 
		else if (noteContent === emptyEditorContentPlainText)
		{
			const editorContent = plainTextToEditorContent(noteContent);

			const rawContent = convertToRaw(editorContent);

			return JSON.stringify(rawContent);
		}

		const jsonContentArray = extractJsonsWithPreText(noteContent);
	
		const statesArray = jsonContentArray.flatMap(({ pre, json }) => [
			plainTextToEditorContent(pre),
			rawToEditorContent(json)
		]);

		if(statesArray.length === 0) {
			const editorContent = plainTextToEditorContent(noteContent);
			const rawContent = convertToRaw(editorContent);
			return JSON.stringify(rawContent);
		} else {
			const result = mergeContentStates(statesArray);
	
			return JSON.stringify(result);
		}
	}

	fetchInfoData = controlId => {
		let url = PropertyBucket.getMyControlDetailByControlId(this.controlId);
		let response = httpService.getService(url, 'GET');
		response.then(data => {
			let postControlDocument = data.postControlDocuments.find(el => el.postControlNote && el.postControlNote.id == this.noteId);
			
			const noteContent = this.parseNoteContent(postControlDocument.postControlNote.noteContent);

			let postControlNoteDocument = postControlDocument.postControlNote;
			let attachmentsMap = mapNewAttachments(postControlNoteDocument, data);
			this.setState({
				controlData: data,
				noteData: postControlNoteDocument,
				noteDataSource: postControlNoteDocument,
				noteContent: noteContent,
				postControlDocumentId: postControlDocument.id,
				attachments: serializeInitialAttachmentsForForm(attachmentsMap || []),
				isWaiting: false,
			})
		})
			.catch(error => {
				this.setState({
					showPopup: true,
					popUp: {title: 'Błąd', notification: error.message, type: 'error'},
					isWaiting: false
				})
			});
	};



	isNotEditableNotFinalInfo() {
		const controlData = this.state.controlData;
		return controlData && (this.isDoneStatus(controlData) || this.isFinalDate(controlData))
	}

	isDataChanged = (value) => {
		const isDataChanged =  value !== this.state.noteContent
		if (isDataChanged && this.state.isChangeRoutePossible){
			this.setState({isChangeRoutePossible: false})
		}
		else if (!isDataChanged && !this.state.isChangeRoutePossible) {
			this.setState({isChangeRoutePossible: true })
		}

		if (this.isNotEditableNotFinalInfo()) {
			this.props.history.replace('/my_controls/' + this.controlId + '/post_control_note_detail/' + this.noteId);
		}
	}

	isDoneStatus = (infoData) => {
		return isZrealizowana(infoData);
	};

	isFinalDate = (infoData) => {
		const docINF = infoData?.postControlDocuments.find(el => el.postControlNote && !el.postControlNote.finalNoteSendDate);
		return docINF?.postControlNote?.finalNoteSendDate !== null;
	};


	preventChangeRoute = (newLocation) => {
		this.setState({
			showPopup: true,
			popUp: {
				title: 'Ostrzeżenie',
				notification: PropertyBucket.getCancelMessage(),
				type: 'cancel',
				newLocationLink: newLocation,
				onClickEvent: this.changeRoute
			},
			isPreventPromptEnabled: false
		});

		return false;
	};

	changeRoute = () => {
		this.setState({
			isPreventPromptEnabled: false
		});

		this.state.popUp.newLocationLink && this.props.history.push(this.state.popUp.newLocationLink)
	};

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	showPopup = (title, notification, type, onClickEvent) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type, onClickEvent: onClickEvent}
		})
	};

	redirectToMyControlActive = () => {
		this.props.history.push('/my_controls/active')
	};

	onDeleteButtonClick = () => {
		this.showPopup('Komunikat', PropertyBucket.deletePostControlNoteConfirmationMessage(), 'confirm', () => {
			this.handleDeleteNote()
		})
	};

	handleDeleteNote = () => {
		this.isWaitingOnOff(true);
		let postControlDocumentId = this.state.postControlDocumentId;
		let controlId = this.controlId;

		let url = PropertyBucket.getDeletePostControlDocument(controlId, postControlDocumentId);
		let callPromise = httpService.getService(url, 'DELETE', null);
		let _this = this;

		callPromise.then(
			function (message) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Komunikat', PropertyBucket.deletePostControlNoteMessage(), 'notify', () => {
					_this.redirectToMyControlActive()
				})
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error.message ? error.message : error, 'error')
			}
		)
	};

	handleSaveNote = ({ noteContent, attachments }) => {
		let _this = this;

		_this.isWaitingOnOff(true);
		let postControlNoteDto = new PostControlNoteDto();
		postControlNoteDto.noteContent = noteContent;
		postControlNoteDto.attachments = attachments;

		let postControlDocument = new NewPostControlDocumentDto();
		postControlDocument.id = this.state.postControlDocumentId;
		postControlDocument.postControlNote = postControlNoteDto;

		let url;
		let callPromise;

		//edycja istniejącej NOTE
		url = PropertyBucket.getEditPostControlDocument(this.controlId, this.state.postControlDocumentId);
		callPromise = httpService.getServicePromise(url, 'POST', postControlDocument, true)


		callPromise.then(
			function (message) {
				_this.setState({
					disabledValidate: false,
					disabledSave: true
				});
				_this.isWaitingOnOff(false);
				_this.showPopup('Komunikat', PropertyBucket.savePostControlNoteMessage());
				_this.fetchInfoData(_this.infoId)
			},
			function (error) {
				_this.isWaitingOnOff(false);
				if (error.status === 409) {
					_this.showPopup('Błąd', 'Informacja lub notatka pokontrolna jest nieedytowalna.', 'error');
					_this.setState({
						disabled: true
					})
				} else {
					_this.showPopup('Błąd', error.message ? error.message : error, 'error')
				}
			}
		)
	};

	handleChange = (e) => {
		this.setState({
			noteContent: e.target.value,
			disabled: ''
		});

	};

	goBack = () => {
		this.props.history.goBack();
	};

	render() {
		let control = this.state.controlData;
		let popUp;
		this.state.showPopup ?
			popUp = <PopUp type={this.state.popUp.type}
						   title={this.state.popUp.title}
						   notification={this.state.popUp.notification}
						   link={this.state.popUp.link ? this.state.popUp.link : null}
						   onClickEvent={this.state.popUp.onClickEvent}
						   closePopUp={this.handleClosePopUp}
			/> : null;
		return (
			<>
				{this.state.isPreventPromptEnabled && <Prompt when={!this.state.isChangeRoutePossible} message={this.preventChangeRoute}/>}
				<div id='post-control-note' className='post-control-note'>
					{popUp}
					{control ? <PostControlForm
									attachments={this.state.attachments}
									control={control}
									noteContent={this.state.noteContent}
									noteData={this.state.noteData}
									onDeleteButtonClick={this.onDeleteButtonClick}
									handleShortChange={this.isDataChanged}
									handleSaveNote={this.handleSaveNote}
									setAttachments={attachments => this.setState({
										attachments: attachments
									})}
						/> :
						<button className='btn save-btn' id='plus_img_container' onClick={this.goBack}><i data-v-db6946bc=''
																										  aria-hidden='true'
																										  className='v-icon material-icons theme--light v-list-text'>arrow_back</i><span>WRÓĆ</span>
						</button>
					}

					<div className='controlListBlocks'>
						<h4 className='mt-4'>Dane audytowe:</h4>
						{<AuditDetail
							auditData={{
								createdOn: this.state?.noteData?.dataCreatedOn,
								createdByLogin: this.state?.noteData?.dataCreatedByLogin,
								createdBy: this.state?.noteData?.dataCreatedBy,
								updatedOn: this.state?.noteData?.dataUpdatedOn,
								updatedByLogin: this.state?.noteData?.dataUpdatedByLogin,
								updatedBy: this.state?.noteData?.dataUpdatedBy,
							}}
						></AuditDetail>}
					</div>

					<div id='waiter'><Waiter loading={this.state.isWaiting}/></div>

				</div>
			</>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchControlData: url => dispatch(actions.getControlData(url)),
	}
};

export const CreatePostControlNoteProvider = connect(mapStateToProps, mapDispatchToProps)(CreatePostControlNote);
